import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    isDynamicFormStep() {
      return Object.values(this.formDialogs).some(dialog => dialog === true);
    },
    ...mapGetters({
      formDialogs: 'dynamicForms/formDialogs'
    })
  },
  methods: {
    async resendPhoneVerification() {
      await this.setDialogLoading(true);
      await this.$http
        .post('/v3/fe/web-users/resend-2fa-code?type=2')
        .then(() => {
          this.setVerificationResult('');
        })
        .catch(async err => {
          if (err.status === 400) {
            this.setVerificationResult('error_timeout');
          }
          if (err.status === 429) {
            this.setVerificationResult('error_block');
          }
        })
        .finally(() => this.setDialogLoading(false));
    },
    ...mapActions({
      setDialogLoading: 'profile/phoneVerification/setDialogLoading',
      setVerificationResult: 'profile/phoneVerification/setVerificationResult'
    })
  }
};
